export default __webpack_public_path__ + "static/media/action_tick.e931dfe8.svg";